import { useEffect, useRef, useState } from 'react';

export const useNotInViewCount = (dependencies: unknown[] = []) => {
  const [notInViewCount, setNotInViewCount] = useState<number>(0);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current?.children.length) {
      setNotInViewCount(0);
      return;
    }
    const handleIntersection = (entries: IntersectionObserverEntry[]) => {
      if (entries.length === containerRef.current?.children.length) {
        const notInViewCount = entries.filter(entry => !entry.isIntersecting).length;
        setNotInViewCount(notInViewCount);
        return;
      }

      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          setNotInViewCount(current => current + 1);
        } else {
          setNotInViewCount(current => current - 1);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      root: containerRef.current,
      threshold: 1,
      rootMargin: '0px'
    });

    const childrenInContainer = Array.from(containerRef.current!.children);
    childrenInContainer.forEach(chip => {
      observer.observe(chip);
    });

    return () => {
      observer.disconnect();
    };
  }, [containerRef, ...dependencies]);

  return { notInViewCount, containerRef };
};
